import React from "react";
import styled from "styled-components";
import _ from "lodash";

const PanelWrapper = styled.div`
    // border: 1px solid blue;
    // display: flex;
    // overflow-x: auto;
    // width: 700px;
    margin-top: 16px;
    .slick-track .slick-slide{
        box-sizing: border-box;
    }
    .slick-track .slick-slide:first-child{
        padding-right: 8px;
        padding-left: 4px;
        // border: 1px solid red;
    }
    .slick-track .slick-slide:not(:first-child):not(:last-child){
        padding-left: 8px;
        padding-right: 8px;
        // border: 1px solid green;
    }
    .slick-track .slick-slide:last-child{
        padding-left: 8px;
        // border: 1px solid blue;
    }
`;

const TabPanel = (props) => {

    return(
        <PanelWrapper ref={props?.panelWrapperRef || undefined} className={props?.panelWrapperClass}>
            {props?.children || null}
        </PanelWrapper>
    )
}

export default TabPanel;